/*
 * Constants
 ***************************/
 var $ = jQuery.noConflict()
 const mobileBreakpoint = parseInt(artVars.breakpoints.mobile_max);
 const navBreakpoint = parseInt(artVars.breakpoints.mobile_navigation_max);
 const windowResizeActions = [];
 let scrollTop = $(window).scrollTop(),
     navTrigger = 0;

 /*
  * Viewport height adjustments
  ***************************/
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
 // We execute the same script as before
 let vh = window.innerHeight * 0.01;
 document.documentElement.style.setProperty('--vh', `${vh}px`);
});

/*
 * Globals
 ***************************/
  /* Window */
    let windowWidth = $(window).width();
    let windowHeight = $(window).height();
    let windowScrollHeight = document.querySelector('body').scrollHeight;
  /* Breakpoints */
    let isMobile = ( windowWidth <= mobileBreakpoint );
    let isMobileNavigationActive = ( windowWidth <= navBreakpoint );
  /* Navigation */
    let isMenuOpen = false,
        isTakeoverMenuOpen = false,
        isSearchOpen = false;

  /* Ajax */
    let currentPage = 1;
    let ajaxIsLoading = false;
    let isDoneLoadingThings = false;
    let currentUrl = window.location.href;

  /* Slick Options */
    const prevArrow = '<button type="button" class="slick-big-arrow slick-prev"><span class="screen-reader-text">Previous</span></button>';
    const nextArrow = '<button type="button" class="slick-big-arrow slick-next"><span class="screen-reader-text">Next</span></button>';


const handleKeypressADA = function() {
  const keycode = (event.keyCode ? event.keyCode : event.which);
  if (keycode == '13') return;
  $(this).trigger('click');
};

$(window).on('load', function() {
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
});

$(document).ready(function(){
  const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

  gsap.registerPlugin(ScrollTrigger, Flip);

  /* Generic */
  if ( $('.modal-area').length ) {
    $('.modal-area').each(function(){
      const prop = $(this).data('propid');

      $(this).find('.modal-area__dismiss').on('click', function(){
        $(this).closest('.modal-area').removeClass('active');
        window.localStorage.setItem( prop, 'true' );
      }).on('keypress', handleKeypressADA);

      const element = $(this).get(0);

      $(this).on('click', function(e){
        if (e.target !== element && !element.contains(e.target)) {
          $(this).removeClass('active');
          window.localStorage.setItem( prop, 'true' );
        }
      });

      const modalDismissed = window.localStorage.getItem( prop );
      if ( modalDismissed != 'true' ) {
        const modal = $(this);
        setTimeout(function(){
          modal.addClass('active');
        }, $(this).data('delay'));
      }
    });
  }

  if ( $('.smooth-scroller').length ) { // internal links, smooth scrolling
    $('.smooth-scroller').on('click', function(e){
      e.preventDefault();
      let target = $( $(this).attr('href') ).offset().top - 148;
      let dist = Math.abs($(window).scrollTop() - target);

      $([document.documentElement, document.body]).animate({
        scrollTop: target
      }, Math.min(1200, ((dist / 1200) * 1000)));
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.copybutton').length ) {
    $('.copybutton').on('click', function(e){
      e.preventDefault();
      const targetEl = $( $(this).data('target') ).get(0);
      const alertEl = $( $(this).data('alert') ).get(0);
      targetEl.select()
      targetEl.setSelectionRange(0, 9999999);
      document.execCommand("copy");
      $(alertEl).fadeIn();
      setTimeout(function(){
        $(alertEl).fadeOut();
      }, 6000);
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.modaltrigger').length ) {
    $('.modaltrigger').on('click', function(e){
      e.preventDefault();
      $(this).addClass('active');
      $(this).attr('aria-expanded', true );
      $($(this).attr('href')).addClass('active');
      $('#masthead').removeClass('scrolled-back');
      $('#masthead').addClass('scrolled');
      $('body').addClass('no-scroll');
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.modalclose').length ) {
    $('.modalclose').on('click', function(e){
      e.preventDefault();
      const controlledBy = $(this).data('controlledby');
      $(this).closest('.modal').removeClass('active');
      $(controlledBy).removeClass('active');
      $(controlledBy).attr('aria-expanded', false);
      $('body').removeClass('no-scroll');
    }).on('keypress', handleKeypressADA);
  }
  /* END GENERIC SCRIPTS */

  /* NAVIGATION SCRIPTS */
  if ( $('.site-header__nav').length ) {
    const navResizeAction = (updated, navUpdated) => {
      if ( navUpdated ) {
        if ( isMobileNavigationActive ) {
          $('#site-nav').attr('role', 'dialog');
          $('#site-nav').attr('aria-modal', 'true');
          $('.site-header__res').insertBefore( $('.site-header__nav-toggle') );
        } else {
          const navEl = $('#site-nav').get(0);
          navEl.removeAttribute('role');
          navEl.removeAttribute('aria-modal');
          $('.site-header__res').insertAfter( $('#site-nav') );
        }
      }
    };

    navResizeAction(true, true);
    windowResizeActions.push(navResizeAction);

    const mobileNavContainer = $('.site-header__nav-inner');
    const mobileToggle = $('.site-header__nav-toggle');
    const mobileDismiss = $('.site-header__nav-dismiss');
    const firstFocusableMenuElement = $(mobileNavContainer).find('a, button, input').eq(0).get(0);
    const lastFocusableMenuElement = mobileDismiss.get(0);

    console.log(firstFocusableMenuElement, lastFocusableMenuElement);

    if ( $(mobileNavContainer).find('.menu-item-has-children') ) {
      $(mobileNavContainer).find('.menu-item-has-children').each(function(){
        const toggle = $(this).children('a, button');
        const submenu = $(this).children('.sub-menu')

        let target = $(toggle).attr('aria-controls');
        let expanded = $(toggle).attr('aria-expanded');

        const toggleResizeAction = (updated, navUpdated) => {
          if ( navUpdated ) {
            if ( isMobileNavigationActive ) {
              $(toggle).attr('aria-controls', target);
              $(toggle).attr('aria-expanded', expanded);
            } else {
              $(toggle).get(0).removeAttribute('aria-controls');
              $(toggle).get(0).removeAttribute('aria-expanded');
            }
          }
        };
        toggleResizeAction(true);

        toggle.on('click', function(){
          if ( isMobileNavigationActive ) {
            expanded = expanded == 'true' ? 'false' : 'true';
            $(toggle).attr('aria-expanded', expanded);
            submenu.slideToggle();
          }
        }).on('keypress', handleKeypressADA);
      });
    }

    $('.site-header__nav-toggle').on('click', function(){
      $(this).toggleClass('active');
      if ( $(this).hasClass('active') ) {
        $(mobileNavContainer).css({
          'visibility': 'visible',
          'pointer-events': 'auto'
        });
        gsap.to(mobileNavContainer, {
          duration: 0.8,
          ease: 'power3.inOut',
          clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
          onComplete: function(){
            $(mobileNavContainer).focus();
          }
        });

        if ( $('.location-menu').length && window.scrollY >= document.querySelector('.location-menu').offsetTop - document.querySelector('#masthead').offsetHeight ) {
          gsap.to('.location-menu', {
            y: mobileNavContainer.outerHeight(),
            duration: 0.8,
            ease: 'power3.inOut'
          });
        }
      } else {
        gsap.to(mobileNavContainer, {
          duration: 0.8,
          ease: 'power3.inOut',
          clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
          onComplete: function(){
            $('.site-header__nav-inner').css({
              'visibility': 'hidden',
              'pointer-events': 'none'
            });
          }
        });

        if ( $('.location-menu').length ) {
          gsap.to('.location-menu', {
            y: 0,
            duration: 0.8,
            ease: 'power3.inOut'
          });
        }
      }
    }).on('keypress', handleKeypressADA);

    $(mobileDismiss).on('click', function(){
      if ( isMobileNavigationActive ) {
        gsap.to(mobileNavContainer, {
          duration: 0.8,
          ease: 'power3.inOut',
          clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
          onComplete: function(){
            $('.site-header__nav-inner').css({
              'visibility': 'hidden',
              'pointer-events': 'none'
            });
          }
        });

        $(mobileToggle).removeClass('active');
        $(mobileToggle).focus();
      }
    }).on('keypress', handleKeypressADA);

    $(mobileNavContainer).on('keydown', function(e){
      if ( isMobileNavigationActive ) {
        console.log(e);
        if ( e.key == 'Escape' ) {
          mobileDismiss.click();
        } else if(e.target == firstFocusableMenuElement && e.key == 'Tab' && e.shiftKey) {
          e.preventDefault();
          lastFocusableMenuElement.focus();
        } else if(e.target == lastFocusableMenuElement && e.key == 'Tab' && !e.shiftKey) {
          e.preventDefault();
          firstFocusableMenuElement.focus();
        }
      }
    });
  }

  $('.site-header__res').each(function(){
    const thisRef = this;
    const resToggle = $(this).find('.has-dropdown');
    if ( resToggle.length === 0 ) return; 
    const resList = $(this).find('.site-header__res-dropdown');
    const resListItems = $(this).find('.site-header__res-dropdown-item');
    const resTL = gsap.timeline({
      paused: true,
      repeat: 0,
      onStart: function() {
        $(resList).css('visibility', 'visible');
        $(resList).css('pointer-events', 'auto');
      },
      onComplete: function(){
        $(resList).css('visibility', 'visible');
        $(resList).css('pointer-events', 'auto');
      },
      onReverseComplete: function(){
        $(resList).css('visibility', 'hidden');
        $(resList).css('pointer-events', 'none');
      }
    });

    $(resListItems).each(function(){
      const thisRef = this;
      resTL.to(this, {
        opacity: 1,
        duration: 0.3,
      }, '-=0.2')
    });

    const dur = resTL.duration();
    resTL.to(resList, {
      height: 'auto',
      duration: dur
    }, '-=' + dur);

    gsap.set(resList, {
      height: 0
    });

    resToggle.on('click', function(){
      $(resToggle).toggleClass('active');
      $(resToggle).attr('aria-expanded', $(resToggle).hasClass('active') ? 'true' : 'false');
      $(resToggle).hasClass('active') ? resTL.restart() : resTL.reverse();
    }).on('keypress', handleKeypressADA);

    $(window).on('click', function(e){
      if ( $(resToggle).hasClass('active') ) {
        if ( e.target !== $(resToggle).get(0) && !$(resToggle).get(0).contains(e.target) && e.target !== $(resList) && !$(resList).get(0).contains(e.target) ) {
          $(resToggle).trigger('click');
        }
      }
    });
  });
  /* END NAVIGATION SCRIPTS */

  /* GUTENBERG BLOCK SCRIPTS */
  if ( $('.location-menu').length ) {
    $('.location-menu').each(function(){
      const thisRef = this;
      const id = $(this).attr('id');
      const toggle = $(this).find('.location-menu__toggle');
      const innerBlocks = $(this).children('.acf-innerblocks-container');
      innerBlocks.attr('id', id + '-innerblocks');
      toggle.attr('aria-controls', id + '-innerblocks');

      if ( $('.wp-block-navigation-item.active-nav-item').length ) {
        $('.wp-block-navigation-item.active-nav-item').each(function(){
          $(this).find('a').first().attr('aria-current', 'page');
        });
      }

      $(toggle).on('click', function(){
        const expanded = $(this).attr('aria-expanded');
        $(this).attr('aria-expanded', expanded == 'true' ? 'false' : 'true');
        if ( $(this).attr('aria-expanded') === 'true' ) {
          $(innerBlocks).css({
            'visibility': 'visible',
            'pointer-events': 'auto'
          });
          gsap.to(innerBlocks, {
            duration: 0.8,
            ease: 'power3.inOut',
            clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
          });
        } else {
          gsap.to(innerBlocks, {
            duration: 0.8,
            ease: 'power3.inOut',
            clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
            onComplete: function(){
              $(innerBlocks).css({
                'visibility': 'hidden',
                'pointer-events': 'none'
              });
            }
          });
        }
      });
    });
  }

  if ( $('.reservation-link.proxy').length ) {
    $('.reservation-link.proxy').each(function(){
      $(this).on('click', function(){
        $('#masthead').find('.reservation-link[data-location-id="' + $(this).data('location-id') + '"]').trigger('click');
      })
    });
  }

  if ( $('.header-hero.has-background-type-video').length ) {
    $('.header-hero.has-background-type-video').each(function(){
      if ( $(this).closest('.header-carousel').length === 0 ) {
        const video = $(this).find('.header-hero__background video, .header-hero__embed');
        window.localStorage.removeItem("plyr")
        const player = new Plyr(video.get(0), {
          controls: ['play'],
          hideControls: false,
          autoplay: true,
          muted: true,
          playsinline: true,
          vimeo: { byline: false, portrait: false, title: false, speed: true, transparent: false, background: true },
          loop: {
            active: true
          }
        });
      }
    });
  }
  
  if ( $('.header-carousel').length ) {
    $('.header-carousel').each(function(){
      const container = $(this).find('.header-carousel__inner');
      const slides = $(this).find('.header-carousel__inner > *');
      const backgrounds = $(this).find('.header-carousel__backgrounds-inner');
      const arrContainer = $(this).find('.header-carousel__controls-arrs');
      const curNum = $(this).find('.header-carousel__controls-nums--cur');
      const totNum = $(this).find('.header-carousel__controls-nums--tot');
      const autoplayToggle = $(this).find('.header-carousel__controls-autoplaytoggle');
      let isAutoplaying = autoplayToggle.hasClass('playing');
      const autoplaySpeed = $(this).data('autoplayspeed');
      
      totNum.text((( slides.length ) + '').padStart(2, '0'));
      
      slides.each(function() {
        if ( $(this).is('.header-hero') ) {
          const clone = $(this).find('.header-hero__background');
          clone.wrap('<div class="header-carousel__backgrounds-slide"></div>');
          
          backgrounds.append(clone.parent());
        }
      });
      
      const players = {
        
      };
      
      $(backgrounds).find('.header-hero__background').each(function(index){
        if ( $(this).is('.is-background-type-video') ) {
          const video = $(this).find('video, .header-hero__embed');
          window.localStorage.removeItem("plyr")
          const player = new Plyr(video.get(0), {
            controls: ['play-large', 'mute'],
            hideControls: false,
            autoplay: index === 1 ? true : false,
            muted: true,
            playsinline: true,
            loop: {
              active: true
            }
          });
          
          players[index] = player;
          
          if ( index === 0 ) {
            player.play();
          }
        }
      });
      
      
      backgrounds.on('init', function(){
        if ( players.hasOwnProperty(0) ) {
          players[0].play();
        }
      }).slick({
        fade: true,
        arrows: false
      });
      
      container.slick({
        swipe: false,
        appendArrows: arrContainer,
        asNavFor: backgrounds,
        prevArrow: prevArrow,
        nextArrow: nextArrow
      });
      
      const autoplayTL = gsap.timeline({
        repeat: -1,
        paused: !isAutoplaying,
        onRepeat: function() {
          $(container).slick('slickNext');
        }
      });
      
      $(container).on('beforeChange', function(event, slick, currentSlide, nextSlide){
        curNum.text(((nextSlide + 1) + '').padStart(2, '0'));
        if ( players.hasOwnProperty(currentSlide) ) {
          players[currentSlide].pause();
        }
        
        if ( isAutoplaying ) {
          autoplayTL.seek(0);
        }
      });
      
      $(container).on('afterChange', function(event, slick, currentSlide){
        if ( players.hasOwnProperty(currentSlide) ) {
          players[currentSlide].play();
        }
      });
       
       
       
      autoplayTL.to($(this).find('.header-carousel__progress-per'), {
        scaleX: 1,
        ease: 'none',
        duration: autoplaySpeed
      });
      
      $(autoplayToggle).on('click', function(){
        isAutoplaying = !isAutoplaying;
        if ( isAutoplaying ) {
          $(autoplayToggle).removeClass('paused');
          $(autoplayToggle).addClass('playing');
          $(this).find('.screen-reader-text').text( $(this).data('pausetext') );
          autoplayTL.play();
          console.log(autoplayTL);
        } else {
          $(autoplayToggle).removeClass('playing');
          $(autoplayToggle).addClass('paused');
          $(this).find('.screen-reader-text').text( $(this).data('playtext') );
          autoplayTL.pause();
        }
      });
    });
  }

  if ( $('.wp-block-cover.alignfull').length ) {
    $('.wp-block-cover.alignfull').each(function(){
      $(this).addClass('has-background');
    });
  }

  if ( $('.embed-pdf-viewer').length ) {
    $('.embed-pdf-viewer').each(function(){
      if ( this.hasAttribute('width') && this.hasAttribute('height') ) {
        this.style.aspectRatio = this.getAttribute('width') + '/' + this.getAttribute('height');
      }
    });
  }
  
  if ( $('.wp-block-video, .wp-block-embed.is-provider-youtube, .wp-block-embed.is-provider-vimeo').length ) {
    $('.wp-block-video, .wp-block-embed.is-provider-youtube, .wp-block-embed.is-provider-vimeo').each(function(){
      const target = $(this).find('video, .wp-block-embed__wrapper');
      const el = target.get(0);

      const isTextural = $(this).closest('.two-up-section.textural-header, .two-up-section.textural-default').length === 0 ? false : true;
      
      const controls = isTextural ? ['play'] : ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'];
      const shouldAutoplay = isTextural ? true : (el.hasAttribute('autoplay') ? (el.getAttribute('autoplay') === 'true' || el.getAttribute('autoplay') === '') : false);
      
      const args = {
        autoplay: shouldAutoplay,
        controls: $(el).is('video') && el.hasAttribute('controls') ? ( el.getAttribute('controls') === 'false' ? [] : controls ) : ($(el).is('video') ? [] : controls),
        playsinline: el.hasAttribute('playsinline') ? (el.getAttribute('playsinline') === 'true' || el.getAttribute('playsinline') === '') : false,
        loop: isTextural ? {active: true} : (el.hasAttribute('loop') ? ( (el.getAttribute('loop') === 'true' || el.getAttribute('loop') === '') ? {active: true} : {active: false}) : {active: false}),
        muted: shouldAutoplay ? true : ( el.hasAttribute('muted') ? (el.getAttribute('muted') === 'true' || el.getAttribute('muted') === '') : false ),
        hideControls: isTextural ? false : true
      };
      
      const player = new Plyr(el, args);
    });
  }
  
  if ( $('.wp-block-audio').length ) {
    $('.wp-block-audio').each(function() {
      const target = $(this).find('audio');
      const el = target.get(0);
      
      const controls = ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'];
      const shouldAutoplay = el.hasAttribute('autoplay') ? (el.getAttribute('autoplay') === 'true' || el.getAttribute('autoplay') === '') : false;
      
      const args = {
        autoplay: shouldAutoplay,
        loop: el.hasAttribute('loop') ? ( (el.getAttribute('loop') === 'true' || el.getAttribute('loop') === '') ? {active: true} : {active: false}) : {active: false},
      };
      
      const player = new Plyr(el, args);
    });
  }
  
  if ( $('.wp-block-gallery').length ) {
    $('.wp-block-gallery').each(function(){
      gutenbergSlickify(this);
    });
  }

  if ( $('.two-up-section.textural-header').length ) {
    $('.two-up-section.textural-header').each(function(){
      const inner = this.querySelector('.two-up-section-inner');
      if ( inner === null ) return;

      const swapSectionElements = ((updated) => {
        if ( updated ) {
          if ( isMobile ) {
            this.querySelector(':scope > .acf-innerblocks-container').append( inner );
          } else {
            this.querySelector(':scope > .acf-innerblocks-container').prepend( inner );
          }
        }
      }).bind(this);
      
      if ( isMobile ) {
        swapSectionElements(true);
      }
      
      windowResizeActions.push( swapSectionElements );
    });
  }
  
  // dropdowns
  if ( $('.art-dropdown').length ) {
    $('.art-dropdown').each(function(){
      const toggle = $(this).find('.art-dropdown__toggle');
      const wrapper = $(this).find('.art-dropdown__inner');
      const dropdown = $(this).find('.art-dropdown__dropdown');
      let isAnimating = false;
      
      $(dropdown).css({
        width: 'auto'
      });
      
      $(wrapper).css({
        'width': Math.round(dropdown.width() + 16) + 'px'
      });
      
      $(dropdown).css({
        width: '100%'
      });
      
      const openDropdown = (e) => {
        $(toggle).attr('aria-expanded', 'true');
        
        $(dropdown).css({
          'visibility': 'visible',
          'pointer-events': 'auto'
        });
        gsap.to(dropdown, {
          clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
          ease: 'power2.inOut',
          overwrite: true
        });
      };
      
      const closeDropdown = (e) => {
        $(toggle).attr('aria-expanded', 'false');
        
        gsap.to(dropdown, {
          clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
          ease: 'power2.inOut',
          overwrite: true,
          onComplete: function(){
            $(dropdown).css({
              'visibility': 'hidden',
              'pointer-events': 'none'
            });
          }
        });
      };
      
      toggle.on('click', function(e){        
        if ( $(this).attr('aria-expanded') == 'true' ) {
          closeDropdown(e);
        } else {
          openDropdown(e);
        }
      });
      
      if ( window.matchMedia('pointer: fine') ) {
        $(this).on('mouseenter', function(e){
          openDropdown(e);
        });
        
        $(this).on('mouseleave', function(e){
          closeDropdown(e);
        });
      }
      
      if ( $(this).find('.art-dropdown__input-input') ) {
        console.log($(this).find('.art-dropdown__input-input'));
        $(this).find('.art-dropdown__input-input').on('change', function(){
          if ( $(this).is(':checked') ) {
            $(toggle).text( $(this).siblings('.art-dropdown__input__label').text() );
          }
        });
      }
    });
  }

  //accordion
  if ( $('.accordion-inner').length ) {
    $('.accordion-inner').each(function(){
      const toggle = $(this).find('.accordion-inner__title button');
      const title = $(this).find('.accordion-inner__title');
      const content = $(this).find('.accordion-inner__content');

      if ( ! content.hasClass('open-on-load') ) {
        content.hide();
      }

      toggle.on('click', function(){
        content.slideToggle();
        const expanded = $(this).attr('aria-expanded');
        $(this).attr('aria-expanded', expanded == 'true' ? 'false' : 'true');
        title.toggleClass('expanded');
      }).on('keypress', handleKeypressADA);
    });
  }
  
  if ( $('.logo-ticker').length ) {
    $('.logo-ticker').each(function() {
      const strip = $(this).find('.logo-ticker__strip');
      const thisRef = this;
      let oldSize = $(window).width();
      let stripW = strip.width();
      let curW = stripW;
      let clones = 0;
      let clonesArr = [];
      
      let speed = isMobile ? stripW / 24 : stripW / 50;
      
      while ( curW && curW !== 0 && curW < oldSize * 2 ) {
        curW += stripW;
        clones++;
        const clone = strip.clone(false);
        $(this).append(clone);
        
        gsap.set(clone, {
          x: ( clones * 100 ) + '%'
        });
        
        clonesArr.push(clone);
      }
      
      const loop = gsap.timeline({
        repeat: -1
      });
      
      loop.to(strip, {
        x: '-=100%',
        ease: 'linear',
        duration: () => {
          return speed;
        }
      });
      
      for ( let i = 0; i < clonesArr.length; i++ ) {
        loop.to(clonesArr[i], {
          x: '-=100%',
          ease: 'linear',
          duration: () => {
            return speed;
          }
        }, '0');
      }
      
      $(window).on('resize', function(){
        speed = isMobile ? stripW / 13 : stripW / 30
        if ( oldSize !== $(window).width() && oldSize < $(window).width() ) {
          const newW = $(window).width();
          if ( newW * 2 > curW ) {
            while ( curW && curW !== 0 && curW < newW * 2 ) {
              curW += stripW;
              clones++;
              const clone = strip.clone(false);
              $(thisRef).append(clone);
              
              gsap.set(clone, {
                x: ( clones * 100 ) + '%'
              });
              
              loop.to(clone, {
                x: '-=100%',
                ease: 'linear',
                duration: () => {
                  return speed;
                }
              }, '0');
              
              clonesArr.push(clone);
            }
            
            oldSize = newW;
          }
        }
      });
    });
  }

  if ( $('[role=tablist].automatic').length ) {
    $('[role=tablist].automatic').each(function() {
      const obj = new TabsAutomatic(this);
    });
  }
  /* END GUTENBERG SCRIPTS */

  /* ARCHIVE BLOCK SCRIPTS */
  if ( $('.archive-block').length ) {
    $('.archive-block').each(function(){
      const archiveBlock = $(this);
      const archiveFeed = $(this).find('.archive-block__feed');
      const archivePagination = $(this).find('.archive-block__pagination-container');

      const archiveFilterForm = $(this).find('.archive-block__header');
      const archiveSortInputs = $(this).find('.archive-block__sort__input-input');
      const archiveSearchInput = $(this).find('.archive-block__search-input');
      const archiveSearchConfirm = $(this).find('.archive-block__search-confirm');

      const archiveFilterGroups = $(this).find('.archive-block__filter');


      const base = $(this).data('baseurl');
      let currentURL = $(this).data('currenturl');
      const initPage = $(this).data('page');
      const postType = $(this).data('posttype');
      const exclude = $(this).data('exclude');

      let updateArchive;
      let stateObj = {
        base: base,
        url: currentURL,
        page: initPage,
        sort: 'default',
        postType: postType,
        search: false,
        mode: false,
        exclude: exclude,
        taxonomy: false,
        term: false,
        filters: {}
      };

      if ( this.hasAttribute('data-postsper') ) {
        stateObj.postsPerPage = $(this).data('postsper');
      }

      if ( this.hasAttribute('data-cardargs') ) {
        stateObj.cardArgs = $(this).data('cardargs');
      }
      
      if ( this.hasAttribute('data-taxonomy') ) {
        stateObj.taxonomy = $(this).data('taxonomy');
      }
      
      if ( this.hasAttribute('data-term') ) {
        stateObj.term = $(this).data('term');
      }
      
      if ( this.hasAttribute('data-mode') ) {
        stateObj.mode = $(this).data('mode');
      }
      
      if ( this.hasAttribute('data-searchterm') ) {
        stateObj.search = $(this).data('searchterm');
      }

      const updateURLFromFilters = () => {
        const baseurl = base[0] === '/' ? window.location.protocol + base : base;
        const url = new URL(baseurl);
        if ( stateObj.sort !== 'default' ) {
          url.searchParams.append('sort', stateObj.sort);
        }

        if ( stateObj.mode === 'search' && stateObj.search !== false ) {
          url.searchParams.append('s', stateObj.search);
        } else if ( stateObj.search !== false ) {
          url.searchParams.append('search', stateObj.search);
        }

        if ( Object.keys(stateObj.filters).length ) {
          for ( const filterType in stateObj.filters ) {
            if ( Array.isArray(stateObj.filters[filterType]) ) {
              url.searchParams.append(filterType, stateObj.filters[filterType].join(','));
            } else {
              url.searchParams.append(filterType, stateObj.filters[filterType]);
            }
          }
        }

        stateObj.url = url.toString();
        stateObj.page = 1;

        updateArchive();
      };

      if ( archiveFilterGroups.length ) {
        $(archiveFilterGroups).each(function() {
          const inputs = $(this).find('input');

          $(inputs).each(function(){
            const name = $(this).attr('name');
            const type = $(this).attr('type');
            const val = $(this).attr('value');

            if ( $(this).is(':checked') ) {
              if ( type === 'radio' ) {
                stateObj.filters[ name ] = val;
              } else {
                if ( stateObj.filters.hasOwnProperty(name) ) {
                  stateObj.filters[ name ].push( val );
                } else {
                  stateObj.filters[ name ] = [ val ];
                }
              }
            }

            $(this).on('change', function(){
              if ( $(this).is(':checked') ) {
                if ( type === 'radio' ) {
                  stateObj.filters[ name ] = val;
                } else {
                  stateObj.filters[ name ].push( val );
                }
              } else if ( type === 'checkbox' ) {
                stateObj.filters[ name ] = stateObj.filters[name].filter( e => e !== val );
              }
              
              updateURLFromFilters();
            });
          });
        });
      }

      if ( archiveSortInputs.length ) {
        $(archiveSortInputs).each(function(){
          const val = $(this).attr('value');
          
          if ( $(this).is(':checked') ) {
            stateObj.sort = val;
          }
          
          $(this).on('change', function(){
            if ( $(this).is(':checked') ) {
              stateObj.sort = val;
              updateURLFromFilters();
            }
          });
        });
      }

      if ( archiveSearchInput.length ) {
        if ( archiveSearchInput.val() !== '' ) {
          stateObj.search = archiveSearchInput.val();
        }
      }

      if ( archiveSearchConfirm.length ) {
        archiveSearchConfirm.on('click', function(){
          const searchQuery = archiveSearchInput.val();
          if ( searchQuery !== '' ) {
            if ( stateObj.search !== searchQuery ) {
              stateObj.search = searchQuery;
            }

            updateURLFromFilters();
          } else {
            if ( stateObj.search !== false ) {
              stateObj.search = false;
              updateURLFromFilters();
            }
          }
        }).on('keypress', handleKeypressADA);
      }

      if ( archiveFilterForm.length ) {
        archiveFilterForm.on('submit', function(e){
          e.preventDefault();
          if ( archiveSearchConfirm.length ) {
            archiveSearchConfirm.trigger('click');
          }
        });
      }



      $(archivePagination).on('click', 'a', function(e){
        e.preventDefault();
        if ( ajaxIsLoading === false ) {
          const url = $(e.target).attr('href');
          let page = 1;
          const urlparts = url.split('?')[0].split('/');
          let parsedNum = false;
          for ( let i = urlparts.length - 1; i >= 0; i-- ) {
            if ( urlparts[ i ] != '' ) {
              const parsed = parseInt( urlparts[ i ] );
              if ( !isNaN(parsed) ) {
                parsedNum = parsed;
                break;
              }
            }
          }

          if ( parsedNum !== false ) {
            page = parsedNum;
          }

          console.log(page);


          stateObj.url = url;
          stateObj.page = page;

          updateArchive();
        }
      }).on('keypress', 'a', function(e){
        e.preventDefault();
        $(this).trigger('click');
      });

      const initState = stateObj;

      window.addEventListener('popstate', function(event){
        if ( Object.keys(event.state).length == 0 ) {
          stateObj = initState;
        } else {
          stateObj = event.state;
        }

        updateArchive(true);
      });


      updateArchive = (frompopstate = false) => {
        ajaxIsLoading = true;
        $(archiveBlock).addClass('loading');
        gsap.to(window, {
          scrollTo: archiveBlock.get(0),
          duration: 0.8,
          ease: 'power1.inOut'
        });


        if ( frompopstate === false ) {
          history.pushState(stateObj, '', stateObj.url);
        }

        const args = {
          paged: stateObj.page,
          base: stateObj.base,
          sort: stateObj.sort,
          postType: stateObj.postType,
          exclude: stateObj.exclude,
          taxonomy: stateObj.taxonomy,
          term: stateObj.term,
          mode: stateObj.mode
        };

        if ( stateObj.search !== false ) {
          args.search = stateObj.search;
        } if ( stateObj.hasOwnProperty('postsPerPage') ) {
          args.postsPerPage = stateObj.postsPerPage;
        } if ( stateObj.hasOwnProperty('cardArgs') ) {
          args.cardArgs = stateObj.cardArgs;
        } if ( stateObj.hasOwnProperty('filters') && Object.keys(stateObj.filters).length ) {
          args.filters = stateObj.filters;
        }

        console.log(args);

        $.post(artVars.ajaxURL, {
          action: 'art_get_archive',
          args: args
        }, function(data) {
          console.log(data);
          try {
            const res = JSON.parse(data);
            const state = Flip.getState( archiveFeed.get(0).querySelector('li') );
            $(archiveFeed).html( res.results );
            $(archivePagination).html( res.pagination );

            Flip.from(state, {
              absolute: true,
              duration: 0.6,
              onEnter: elements => gsap.fromTo(elements, {opacity: 0}, {opacity: 1}),
              onLeave: elements => gsap.fromTo(elements, {opacity: 1}, {opacity: 0}),
            });
          } catch (err) {
            console.log( err );
          }
        }).always(function(){
          $(archiveBlock).removeClass('loading');
          ajaxIsLoading = false;
        });
      };
    });
  }
  /* END ARCHIVE BLOCK SCRIPTS */
}); // document ready end

/*
 * Window Resize
 ***************************/
$(window).resize(function(){
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
  let oldState = isMobile;
  let oldNavState = isMobileNavigationActive;
  isMobile = ( windowWidth <= mobileBreakpoint );
  isMobileNavigationActive = ( windowWidth <= navBreakpoint );
  if ( windowResizeActions.length > 0 ) {
    const updated = oldState != isMobile;
    const navUpdated = oldNavState != isMobileNavigationActive;
    for (var i = 0; i < windowResizeActions.length; i++) {
      windowResizeActions[i](updated, navUpdated);
    }
  }
}); // end window resize functions

/*
 * Window Scroll
 ***************************/
$(window).on('scroll', function() {
  navTrigger = scrollTop;
  scrollTop = $(this).scrollTop();
}); // end window scroll functions

/*
 * Functions
 ***************************/
function gutenbergSlickify(el) {
  const count = $(el).find('.wp-block-image').length;
  const slides = $(el).find('.wp-block-image');

  const captions = [];

  $(slides).each(function(){
    if ( $(this).find('.wp-element-caption').length ) {
      $(this).addClass('has-caption');
      captions.push( $(this).find('.wp-element-caption').clone(true) );
      $(this).find('.wp-element-caption').remove();
    } else {
      captions.push('<div class="caption-slide" style="height:10px;"></div>');
    }
  });

  

  $(el).find('.blocks-gallery-item').each(function(){
    $(this).addClass('slick-gallery-item').removeClass('blocks-gallery-item');
  });

  $(el).find('.blocks-gallery-item__caption').each(function(){
    $(this).addClass('slick-gallery-item__caption').removeClass('blocks-gallery-item__caption');
  });

  $(el).addClass('slick-gallery-grid alignwide').removeClass('blocks-gallery-grid');

  $(el).removeClass('wp-block-gallery').wrap('<div></div>');
  const parent = $(el).parent();
  parent.addClass('alignfull content-margins slick-gallery').removeClass('wp-block-gallery').append('<div class="slick-gallery-nav__captions-outer alignwide"><div class="slick-gallery-nav__captions"></div></div><div class="slick-gallery-nav alignwide"><div class="slick-gallery-nav__inner"><div class="slick-gallery-nav__dots"></div><div class="slick-gallery-nav__count has-h-6-font-size">' + count +' Images</div></div></div>');
  parent.prepend('<p class="slick-instructions slick-sr-only">This is a series of carousels that display linked images and associated captions. Use the dot buttons or arrows that appear after the carousels to navigate between slides.</p>')


  const nav = $(el).parent().find('.slick-gallery-nav');
  const captionsContainer = $(parent).find('.slick-gallery-nav__captions');
  for (let i = 0; i < captions.length; i++) {
    captionsContainer.append( captions[i] );
  }

  const captionSlides = $(parent).find('.caption-slide, .wp-element-caption');

  let args = {
    adaptiveHeight: true,
    appendArrows: nav,
    arrowsPlacement: 'afterSlides',
    asNavFor: captionsContainer,
    dots: true,
    appendDots: $(parent).find('.slick-gallery-nav__dots'),
  };

  let captionArgs = {
    adaptiveHeight: true,
    arrows: false,
    swipe: false,
    fade: true,
  }

  if ( count >= 4 ) {
    $(parent).addClass('has-more-slides');
    $(el).addClass('alignfull').removeClass('alignwide');
    $(parent).find('.slick-gallery-nav__captions-outer').addClass('alignfull').removeClass('alignwide');
    $(nav).addClass('alignfull').removeClass('alignwide');

    args = {
      ...args,
      centerMode: true,
      slidesToShow: 3,
      centerPadding: '10vw',
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 1,
            centerPadding: '10vw',
          }
        }
      ]
    };

    captionArgs = {
      ...captionArgs,
    };
  }

  $(captionsContainer).on('init', function(event, slick){
    captionsContainer.get(0).removeAttribute('role');
    captionsContainer.get(0).removeAttribute('aria-label');

    $(captionSlides).each(function(index){
      const slide = $(this).closest('.slick-slide');
      $(slide).attr('role', 'group');
      $(slide).attr('aria-label', 'Caption for slide ' + (index + 1) + ' of ' + count);
    });
  });

  captionsContainer.slick(captionArgs);

  const removeAndApplyRoles = function() {
    el.removeAttribute('role');
    el.removeAttribute('aria-label');
    $(slides).each(function(index){
      const slide = $(this).closest('.slick-slide');
      $(slide).attr('role', 'group');
      $(slide).attr('aria-label', 'Slide ' + (index + 1) + ' of ' + count);
    }); 
  }

  $(el).on('init', removeAndApplyRoles);
  $(el).on('reInit', removeAndApplyRoles);
  $(el).on('breakpoint', removeAndApplyRoles);

  $(el).slick(args);

  removeAndApplyRoles();
  
  const applySlideLabels = function() {
    $(captionSlides).each(function(index){
      const slide = $(this).closest('.slick-slide');
      $(slide).attr('role', 'group');
      $(slide).attr('aria-label', 'Caption for slide ' + (index + 1) + ' of ' + count);
    });

    $(slides).each(function(index){
      const slide = $(this).closest('.slick-slide');
      $(slide).attr('role', 'group');
      $(slide).attr('aria-label', 'Slide ' + (index + 1) + ' of ' + count);
    });
  }

  $(el).on('init', applySlideLabels);
  $(el).on('reInit', applySlideLabels);
  $(el).on('breakpoint', applySlideLabels);

  applySlideLabels();

  $(parent).attr('role', 'region');
  $(parent).attr('aria-label', 'Image carousel');

  $(el).on('beforeChange', function(event, slick, currentSlide, nextSlide){
    nav.find('.slick-gallery-nav__count__cur').text(nextSlide + 1);
  });
}

// Post Header Height
// jQuery(document).ready(function($) {
//   function updateHeaderHeight() {
//     var headerTitle = $('.post-header__title').outerHeight(true);
//     var headerContainer = $('.post-header');
//     var siteHeaderHeight = $('.site-header').height();
//     var newHeight = headerTitle + siteHeaderHeight + 145 + 'px';

//     if ($(window).width() < 959) {
//       newHeight = headerTitle + siteHeaderHeight + 160 + 'px';
//     }
//     if ($(window).width() < 768) {
//       newHeight = headerTitle + siteHeaderHeight + 120 + 'px';
//     }

//     headerContainer.css('height', newHeight);
//   }

//   updateHeaderHeight();
//   $(window).resize(updateHeaderHeight);
// });

// Custom Search Close Button
$(document).ready(function() {
  $('.search-close').on('click', function() {
    $('.site-searchform__input').val('');
  });
});

class TabsAutomatic {
  constructor(groupNode) {
    this.tablistNode = groupNode;

    this.tabs = [];
    this.indicator = false;
    
    this.firstTab = null;
    this.lastTab = null;

    this.tabs = Array.from(this.tablistNode.querySelectorAll('[role=tab]'));
    this.tabpanels = [];

    this.container = groupNode.querySelector('.tabbed-carousel__tabmenu-container');
    this.outer = groupNode.querySelector('.tabbed-carousel__tabmenu-container-outer');

    for (var i = 0; i < this.tabs.length; i += 1) {
      var tab = this.tabs[i];
      var tabpanel = document.getElementById(tab.getAttribute('aria-controls'));

      tab.tabIndex = -1;
      tab.setAttribute('aria-selected', 'false');
      this.tabpanels.push(tabpanel);

      tab.addEventListener('keydown', this.onKeydown.bind(this));
      tab.addEventListener('click', this.onClick.bind(this));

      if (!this.firstTab) {
        this.firstTab = tab;
      }
      this.lastTab = tab;
    }

    this.setSelectedTab(this.firstTab, false);
    this.indicator = document.createElement('span');
    this.indicator.classList.add('indicator');
    this.firstTab.appendChild(this.indicator);

    this.isScrollable = false;
    this.leftArrow = this.tablistNode.querySelector('.tabbed-carousel__tabmenu-arr.left');
    this.rightArrow = this.tablistNode.querySelector('.tabbed-carousel__tabmenu-arr.right');

    this.assessScroll();

    $(window).on('resize', (() => {
      this.assessScroll();
    }).bind(this));

    ScrollTrigger.create({
      scroller: this.container,
      horizontal: true,
      trigger: this.firstTab,
      start: 'top top-=1',
      end: 'bottom top-=10000',
      toggleClass: {
        targets: this.outer,
        className: 'can-scroll-left'
      }
    })

    ScrollTrigger.create({
      scroller: this.container,
      horizontal: true,
      trigger: this.lastTab,
      start: 'bottom bottom+=10',
      end: 'bottom bottom-=400',
      toggleClass: {
        targets: this.outer,
        className: 'cant-scroll-right'
      }
    })

    $(this.leftArrow).on('click', (() => {
      gsap.to(this.container, {
        scrollTo: this.firstTab
      });
    }).bind(this));

    $(this.rightArrow).on('click', (() => {
      gsap.to(this.container, {
        scrollTo: this.lastTab
      });
    }).bind(this));
  }

  assessScroll() {
    this.isScrollable = this.container.scrollWidth > this.container.clientWidth;

    if ( this.isScrollable ) {
      this.outer.classList.add('is-scrollable');
    } else {
      this.outer.classList.remove('is-scrollable');
    }
  }

  setSelectedTab(currentTab, setFocus) {
    if (typeof setFocus !== 'boolean') {
      setFocus = true;
    }
    for (var i = 0; i < this.tabs.length; i += 1) {
      var tab = this.tabs[i];
      if (currentTab === tab) {
        tab.setAttribute('aria-selected', 'true');
        tab.removeAttribute('tabindex');
        this.tabpanels[i].style.display = 'block';
        if (setFocus) {
          tab.focus();
        } if ( this.indicator !== false ) {
          const indState = Flip.getState(this.indicator);
          tab.appendChild(this.indicator);
          Flip.from(indState, {
            duration: 0.4,
            ease: 'power3.inOut'
          })
        } if ( this.isScrollable ) {
          gsap.to(this.container, {
            scrollTo: tab
          });
        }
      } else {
        tab.setAttribute('aria-selected', 'false');
        tab.tabIndex = -1;
        this.tabpanels[i].style.display = 'none';
      }
    }
  }

  setSelectedToPreviousTab(currentTab) {
    var index;

    if (currentTab === this.firstTab) {
      this.setSelectedTab(this.lastTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.setSelectedTab(this.tabs[index - 1]);
    }
  }

  setSelectedToNextTab(currentTab) {
    var index;

    if (currentTab === this.lastTab) {
      this.setSelectedTab(this.firstTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.setSelectedTab(this.tabs[index + 1]);
    }
  }

  /* EVENT HANDLERS */

  onKeydown(event) {
    var tgt = event.currentTarget,
      flag = false;

    switch (event.key) {
      case 'ArrowLeft':
        this.setSelectedToPreviousTab(tgt);
        flag = true;
        break;

      case 'ArrowRight':
        this.setSelectedToNextTab(tgt);
        flag = true;
        break;

      case 'Home':
        this.setSelectedTab(this.firstTab);
        flag = true;
        break;

      case 'End':
        this.setSelectedTab(this.lastTab);
        flag = true;
        break;

      default:
        break;
    }

    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  onClick(event) {
    this.setSelectedTab(event.currentTarget);
  }
}